
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[publicDashboard]",
      function () {
        return require("private-next-pages/org/[publicDashboard].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/org/[publicDashboard]"])
      });
    }
  